export default __webpack_public_path__ + "static/media/sanmar6.4fe44285.jpg";